<div class="t-sidenav grid grid-rows-[auto_5rem] lg:grid-rows-[min-content_auto_8rem]  h-[calc(var(--ra-height,100vh)-5rem)]" *transloco="let t">
   <button
   [attr.aria-label]="t('sidebar.newresearchbutton')"
      class="t-header-new-research-button h-12 gradient-border border-2 rounded-full mb-2 p-3 flex-row text-cdra-blue-light-main font-bold hidden items-center w-fit lg:flex"
      [routerLink]="['/research/new']" (click)="startNewResearchSession()"
   >
      <span class="hidden mx-2 text-center w-fit font-bold leading-4
               lg:inline
               group-data-[showsidenav=true]:inline"
        >{{ t('sidebar.newresearchbutton') }}</span>
   </button>

   <div class="mb-auto h-full overflow-y-auto" tabindex="0">
      <!-- We also have a 'new research' button in header for small screens, this one is for bigger screens -->

      <app-research-history></app-research-history>
      @if(debugEnabled) {
         <app-debug-sidebar></app-debug-sidebar>
        }
   </div>

   <div class="t-sidenav-disclaimer flex flex-col justify-end gap-1 py-1 h-fit text-sm">
      <p>{{ t('sidebar.disclaimer') }}</p>
      <button class="t-sidenav-help-link text-start underline me-2 hover:decoration-2" [routerLink]="helpLink" (click)="log('help', helpLink, false)">{{ t('sidebar.helplink') }}</button>
      <a class="underline hover:decoration-2" href="https://clarivate.com/ai/academia/policy/" (click)="log('disclaimer', 'https://clarivate.com/ai/academia/policy/')" target="_blank">
         {{ t('sidebar.disclaimer.link') }}
      </a>
   </div>


</div>